import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.University;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "University.Phaser.IntroductionScene.1",
            "University.Phaser.IntroductionScene.2",
            "University.Phaser.IntroductionScene.3",
            "University.Phaser.IntroductionScene.4",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/UniversityGame/scenes/GameIntro.ts